export const common = {
  // Navbar
  courseFlow: '코스 흐름',
  curriculum: '커리큘럼',
  pricing: '가격',
  wordPool: '단어 풀',
  levelCheck: '레벨 체크',
  register: '등록',
  myPage: '마이페이지',
  signOut: '로그아웃',
  admin: '관리 화면',
  orgSchedule: '단체 일정',
  
  // Footer
  quickLinks: '빠른 링크',
  home: '홈',
  contact: '문의',
  contactForm: '문의 양식',
  allRightsReserved: 'All rights reserved.',
  websiteBuilder: 'Website Builder',
  
  // Common
  submit: '제출',
  submitting: '제출 중...',
  required: '필수 항목',
  optional: '선택 사항',
  cancel: '취소',
  close: '닫기',
  save: '저장',
  delete: '삭제',
  edit: '편집',
  add: '추가',
  search: '검색',
  filter: '필터',
  loading: '로딩 중...',
  error: '오류가 발생했습니다',
  success: '성공했습니다',
  
  // Brand
  brandName: 'EachTeach',
  brandTagline: '진지한 학습자를 위한 고품질 1:1 언어 교환 서비스',
  additionalLesson: {
    title: '추가 레슨 신청',
    subtitle: '관심 분야의 전문 레슨에 신청하세요',
    backToCourseFlow: '코스 흐름으로 돌아가기',
    specializedFields: '8개 전문 분야',
    chooseYourField: '분야 선택',
    fieldDescription: '각 코스는 특정 직장 시나리오와 커뮤니케이션 요구에 맞게 설계되었습니다',
    lessons: '레슨',
    courses: {
      daily: {
        name: '일상생활 및 캐주얼 커뮤니케이션',
        description: '일상 대화, 잡담, 속어, 관용구, 속담 등 생활과 인간관계에서 사용되는 범용적인 표현을 배웁니다.'
      },
      customerService: {
        name: '고객 서비스 및 환대 커뮤니케이션',
        description: '레스토랑이나 카페 등 접객 현장에서 필요한 주문 대응, 설명, 추천, 불만 처리 등의 표현을 배웁니다.'
      },
      kitchen: {
        name: '주방 및 요리 커뮤니케이션',
        description: '주방이나 조리 현장에서 사용되는 지시 표현, 식재료 및 조리 용어, 안전 확인, 팀 내 협력을 배웁니다.'
      },
      retail: {
        name: '판매 및 계산대 커뮤니케이션',
        description: '소매점이나 상점에서의 접객을 가정하여 상품 설명, 사이즈 및 재고 확인, 결제, 반품 및 교환 대응 등을 배웁니다.'
      },
      hotel: {
        name: '호텔 및 프런트 데스크 업무',
        description: '호텔이나 숙박 시설에서의 업무를 가정하여 체크인/체크아웃, 시설 안내, 문의, 전화 대응, 불만 처리를 배웁니다.'
      },
      cleaning: {
        name: '청소 및 백오피스 업무',
        description: '청소나 백야드 업무에 필요한 지시 이해, 확인 표현, 체크리스트, 안전 관련 표현을 배웁니다.'
      },
      resort: {
        name: '리조트 및 계절 노동',
        description: '관광지나 단기 고용 직장을 가정하여 다국적 환경에서의 팀 내 커뮤니케이션과 접객 표현을 배웁니다.'
      },
      workplace: {
        name: '직장 및 고급 커뮤니케이션',
        description: '취업 후 직장 환경을 가정하여 이메일, 보고, 조정, 의뢰, 문제 공유 등 보다 고급 업무 커뮤니케이션을 배웁니다.'
      }
    },
    form: {
      title: '신청 양식',
      subtitle: '아래 양식을 작성하여 선택한 분야에 신청하세요',
      name: '이름',
      email: '이메일',
      language: '학습 언어',
      firstChoice: '첫 번째 선택',
      secondChoice: '두 번째 선택',
      thirdChoice: '세 번째 선택',
      goals: '학습 목표 및 요청',
      required: '필수',
      optional: '선택',
      selectLanguage: '언어 선택',
      japanese: '일본어',
      korean: '한국어',
      english: '영어',
      selectFirstChoice: '첫 번째 선택을 선택하세요',
      selectSecondChoice: '두 번째 선택을 선택하세요 (선택)',
      selectThirdChoice: '세 번째 선택을 선택하세요 (선택)',
      goalsPlaceholder: '학습 목표나 구체적인 요청을 작성해 주세요 (선택)',
      characters: '자',
      cancel: '취소',
      submit: '신청하기',
      submitting: '제출 중...',
      successMessage: '신청이 성공적으로 제출되었습니다.',
      errorMessage: '모든 필수 항목을 입력해 주세요.',
      submitError: '제출에 실패했습니다. 다시 시도해 주세요.'
    },
    info: {
      title: '추가 레슨에 대하여:',
      point1: '레슨 A-C 완료 후 수강 가능',
      point2: '관심 분야에 특화된 전문 레슨',
      point3: '2-3 영업일 이내에 연락드립니다',
      point4: '최대 3개의 희망 분야를 선택할 수 있습니다'
    }
  }
};
